import { get } from "lodash-es";
import { t } from "i18next";
export function useExportFile() {
    function prepareExport(keyMap, items) {
        const columns = [];
        const rows = [];
        keyMap.forEach(({ column, additionalProps, showCondition }) => {
            var _a, _b;
            if (typeof showCondition === "function" && showCondition() === false) {
                return; // Skip
            }
            if ((_b = (_a = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.appendToHeader) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 > 0) {
                additionalProps.appendToHeader.forEach(x => columns.push(x));
                return;
            }
            columns.push(column);
        });
        items.forEach(item => {
            let row = [];
            keyMap.forEach(({ key, useGivenMethod, additionalProps, showCondition }) => {
                var _a, _b, _c;
                if (typeof showCondition === "function" &&
                    showCondition() === false) {
                    return; // Skip
                }
                if ((additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.isArray) === true) {
                    if (additionalProps.useGivenMethod &&
                        typeof additionalProps.useGivenMethod === "function") {
                        const response = additionalProps.useGivenMethod((_a = get(item, key)) !== null && _a !== void 0 ? _a : [], (_b = additionalProps.appendToHeader) !== null && _b !== void 0 ? _b : []);
                        if (Array.isArray(response)) {
                            row = [...row, ...response];
                            return;
                        }
                        row.push(response);
                        return;
                    }
                    const handledItems = exportHandleArray((_c = get(item, key)) !== null && _c !== void 0 ? _c : [], {
                        fieldKey: additionalProps.fieldKey
                    });
                    if (additionalProps.toString === true) {
                        row.push(handledItems.filter(Boolean).join(", "));
                        return;
                    }
                    row = [...row, ...handledItems];
                    return;
                }
                if (useGivenMethod && typeof useGivenMethod === "function") {
                    row.push(useGivenMethod(item));
                }
                else {
                    row.push(get(item, key, " "));
                }
            });
            rows.push(row);
        });
        return [columns, ...rows];
    }
    async function exportFile({ keyMap, items, exportFileType, filename }) {
        const aoa = prepareExport(keyMap, items);
        // @ts-ignore
        const Excel = await import(/* webpackChunkName: "exceljs" */ "exceljs");
        const link = document.createElement("a");
        link.download = `${filename}.${exportFileType}`;
        const wb = new Excel.Workbook();
        wb.creator = "FIPA";
        wb.created = new Date();
        const sheet = wb.addWorksheet("export");
        aoa.forEach((row, i) => {
            sheet.insertRow(i + 1, row);
        });
        if (exportFileType === "xlsx") {
            const buffer = await wb.xlsx.writeBuffer();
            link.href = URL.createObjectURL(new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }));
        }
        else if (exportFileType === "csv") {
            const buffer = await wb.csv.writeBuffer({
                formatterOptions: {
                    delimiter: ",",
                    writeBOM: true,
                    headers: true,
                    quoteColumns: true
                }
            });
            link.href = URL.createObjectURL(new Blob([buffer], {
                type: "text/csv"
            }));
        }
        link.click();
    }
    return {
        prepareExport, // this is only returned for unit testing
        exportFile
    };
}
export function exportSetPonyValue(ponyType) {
    if (!ponyType || ponyType == "horse")
        return " ";
    switch (ponyType) {
        case "big":
            return t("horses:ponyTypes.big", "Big pony");
        case "medium":
            return t("horses:ponyTypes.medium", "Medium Pony");
        case "small":
            return t("horses:ponyTypes.small", "Small pony");
        case "micro":
            return t("horses:ponyTypes.micro", "Small pony, below 130cm");
        default:
            return t("horses:ponyTypes." + ponyType);
    }
}
export function exportHandleArrayBooleanResponses(items, fieldKey, headers) {
    const value = [];
    const fieldKeys = items.map(x => get(x, fieldKey));
    headers.forEach(header => value.push(fieldKeys.includes(header) ? 1 : 0));
    return value;
}
function exportHandleArray(items, { fieldKey }) {
    return items.map(x => get(x, fieldKey, ""));
}
